module.exports = __webpack_public_path__ + "img/profile-star.54666188.svg";